module.exports = __webpack_public_path__ + "media/images/crew-e62920d3082b333609321e99c72dddf5.jpg";